import classNames from "classnames";
import React from "react";
import css from './PhoneNumber.module.css'

function PhoneNumber({ phoneNumber, className }) {
  const formattedPhoneNumber = phoneNumber?.trim();
  const telHref = formattedPhoneNumber ? `tel:${formattedPhoneNumber.replace(/[^\d+]/g, '')}` : null;

  return (
    <div className={classNames(css.phn, className)}>
      {telHref ? (
        <a href={telHref}>{formattedPhoneNumber}</a>
      ) : (
        <span>{formattedPhoneNumber}</span>
      )}
    </div>
  );
}

export default PhoneNumber;
